import { h, Component } from 'preact'
import * as actions from "../actions";
import designService from "../service/designService";
import ooService from '../service/ooService';
import constants from "../constants";
import store from "../store";
import designDomain from "../domain/designDomain";
import linkRef from "linkref";
import Spinner from '../component/Spinner';
import { getOMLink } from "../util";
import MenuObject from '../canvas/menu-object';
import React from "preact/compat";

const BATCH = 2;

export default class MenuContentDesigns extends Component {
  constructor(props) {
    super(props);
    this.state = {
      businessName: '',
      designId: props.designId,
      designName: '',
      designs: [],
      hasDesigns: false,
      isLoadinng: false,
      lastLoadedPage: 0,
      showOMIframe: true,
    }
  }

  shouldComponentUpdate(props, state) {
    return true
  }

  populateDesigns(page, force) {
    // if (this.state.importFromSampleCopy || !force) return;
    if (this.props.importFromSampleCopy && !force) return;

    const locationId = this.props.locationId

    if (page === 1) {
      this.setState({ designs: [], isLoading: true });
    }

    designService.getMenuObjectDesignsForLocation(locationId, page, BATCH, false).then(resp => {
      if (locationId !== window.data.design.locationId) return;
      if (this.props.importFromSampleCopy) return;
      if (!resp.data) {
        resp.data = {
          list: [],
          hasNext: false
        };
      }

      const designs = (resp.data.list || []).map(it => new designDomain.LightDesign(it));
      designs.forEach(it => it.selected = it.id === this.state.selectedDesign);
      if (page === 1) {
        this.setState({ hasDesigns: designs.length > 0 });
      }
      if (designs.length > 0) {
        let newDesigns = this.state.designs;
        designs.forEach(d => {
          if (!newDesigns.find(it => it.id === d.id)) {
            newDesigns.push(d);
          }
        });
        this.setState({ designs: [...newDesigns] });
      }
      this.setState({ lastLoadedPage: page, isLoading: false });
      if (resp.data.hasNext) {
        this.populateDesigns(page + 1, force);
      }
    })
  }

  onDesignClick(design, ev) {
    const designs = [...this.state.designs];
    designs.forEach(it => it.selected = it.id === design.id);
    this.setState({ design, designId: design.id, designName: design.name });

    this.props.onSelectDesign(design.id, design.name);
  }

  onOnlineMenuIframeClick(om, ev) {
    this.props.onSelectOnlineMenu(om);
  }

  onToggleImportFromForAdmin() {
    if (this.props.isAdmin || this.props.isDesigner) {
      this.props.onSampleDataToggle?.();
    }
  }

  populateDesignsFromBucket(bucket) {
    this.setState({
      locationId: -1,
      designs: [],
      isLoading: true
    });

    designService.getTemplates({
      page: 0,
      pageSize: 100,
      status: bucket,
      orderBy: 'name',
      orderByDirection: 'asc',
    }).then(resp => {
      const designs = (resp.data || []).map(it => new designDomain.LightDesign(it));
      this.setState({
        designs,
        isLoading: false,
        hasDesigns: designs.length > 0
      });
    });
  }

  goBack() {
    this.clearSearchField();
    this.props.onGoBack();
  }

  onClose() {
    this.clearSearchField();
    this.goBack();
  }

  onSearchKeyUp(ev) {
    const value = ev.target.value.toLowerCase();
    const designs = this.state.designs;
    const showOM = ('Online Menus').toLowerCase().indexOf(value) > -1;

    designs.forEach(it => it.visible = it.name.toLowerCase().indexOf(value) > -1);
    this.setState({ designs: [...designs], showOMIframe: showOM });
  }

  clearSearchField() {
    if (this.refs && this.refs.searchField) this.refs.searchField.value = '';
  }

  componentWillReceiveProps(nextProps, nextContext) {
    if (nextProps.importFromSampleCopy) {
      this.populateDesignsFromBucket('samplecopy');
    } else {
      this.populateDesigns(1, true);
    }
  }

  componentDidMount() {
    this.setState({ isLoading: true, showOMIframe: true });

    if (!this.props.importFromSampleCopy) {
      this.populateDesigns(1);
    } else {
      this.populateDesignsFromBucket('samplecopy');
    }
    this.setState({ hasDesigns: this.state.designs.length > 0 });

    // if (this.props.menuObjectImportDesign) {
    //   this.props.onSelectDesign(this.props.menuObjectImportDesign, this.props.menuObjectImportName);
    // }
    //
    // if (this.props.onlineMenuImport) {
    //   this.props.onSelectOnlineMenu(this.props.onlineMenuImport);
    // }
  }

  forceSaveMO() {
    let doneBtn = $('.done-button')[0];
    if (doneBtn) {
      doneBtn.click();
    }
  }

  saveThenClose() {
    this.forceSaveMO();
    setTimeout(() => {
      store.dispatch(actions.hideMenuContentModal());
    }, 50);
  }

  render(props, state) {
    let content = null;
    let optionsDesigns = [];
    let optionOM = '';
    let optionOMs = '';

    if (state.designs.length > 0) {
      optionsDesigns = state.designs
        .filter(it => it.visible)
        .map(design => {
          return <li onClick={(ev) => this.onDesignClick.bind(this)(design, ev)}>
            <a>
              <img alt="" src={`${constants.RENDERER_DOMAIN}/design/thumbnail/${design.id}?width=300`} />
              <h6>{design.name}</h6>
            </a>
          </li>
        });
    }

    if (props.onlineMenus.length > 0 && !props.importFromSampleCopy) {
      optionOM = state.showOMIframe && <li onClick={(ev) => this.onOnlineMenuIframeClick.bind(this)(props.onlineMenus[0], ev)}>
        <a class="om-iframe-container">
          <iframe src={`${getOMLink(props.onlineMenuUrl)}?preview=true`} scrolling="no"></iframe>
          <h6>Online Menus</h6>
        </a>
      </li>;
    }

    if (state.isLoading) {
      content = <Spinner />
    } else {
      if (optionsDesigns.length > 0 || optionOM) {
        content = <ul className="designs">
          {optionOM}
          {optionsDesigns}
        </ul>;
      } else if (!state.hasDesigns) {
        content = <div class="no-menus-found-message">
          <span>👩🏽‍🍳</span>
          <p>
            No saved menus yet.<br />
            Time to whip some up!
          </p>
        </div>;
      } else {
        content = <div class="no-matches-found-message">
          No matches found.
        </div>;
      }
    }

    let contentPosition = "top: 145px; padding: 0 97px;";
    // let contentPosition = optionsDesigns.length === 0 && "top: 140px;"
    let scrollerPosition = "";

    if (this.props.$element && MenuObject.isMenuObject(this.props.$element)) {
      contentPosition = "top: 175px;";

      if (store.getState().isMobileVersion) {
        scrollerPosition += "bottom: 0px;";
        contentPosition = "top: 100px;";
      }
    }

    const showNewItemsBtn = (!this.props.$element || !MenuObject.isMenuObject(this.props.$element)) && store.getState().isMobileVersion;

    return (
      props.subview === 'designs' ?
        <div className="import-from-saved-designs">
          <header>
            <div className="top-content">
              <h4>{props.importFromSampleCopy ? 'Templates | Sample Data' : 'Import Items from a Saved Design'}</h4>
              {(this.props.isAdmin || this.props.isDesigner) &&
                <svg onClick={() => this.onToggleImportFromForAdmin()} className="toggle-button"><use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-sync"} /></svg>}
            </div>
            {!state.isLoading && (state.hasDesigns || optionOM) &&
              <div className={'search'}>
                <input type="text" placeholder="Search by design name" onKeyUp={this.onSearchKeyUp.bind(this)} ref={linkRef(this, 'searchField')} />
                <svg className="search-icon"><use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-search"} /></svg>
              </div>
            }
          </header>

          <div className={`modal-content import-items-content ${!showNewItemsBtn ? 'small-header' : ''} scroller`}>
            {content}
          </div>
        </div>
        : <div></div>
    );
  }
}
